const StatesDb = {
    "payload": [
        {
            "id": 1,
            "name": "Starting"
        },
        {
            "id": 2,
            "name": "Charging"
        },
        {
            "id": 3,
            "name": "Finishing"
        },
        {
            "id": 4,
            "name": "Completed"
        }
    ],
    "status": 200
}

export default StatesDb